import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const YEARS = [
  { year: 7, label: "Year 7", focus: "Foundations: number fluency, algebra basics, geometry intro. Build strong habits early." },
  { year: 8, label: "Year 8", focus: "Fractions mastery, percentages, angles, simple equations, early probability." },
  { year: 9, label: "Year 9", focus: "Linear equations, Pythagoras, sequences, ratio, statistical diagrams." },
  { year: 10, label: "Year 10", focus: "Quadratics, trigonometry, standard form, surds, circle theorems." },
  { year: 11, label: "Year 11", focus: "Full GCSE revision, past papers, mock papers, exam technique." },
];

// Comprehensive GCSE Maths topic coverage (AQA / Edexcel / OCR, Foundation + Higher)
const TOPICS = [
  ["Number", [
    "Place Value", "Fractions", "Decimals", "Percentages", "Ratio & Proportion",
    "Indices / Powers", "Standard Form", "Surds", "Rounding & Estimation",
    "HCF & LCM", "Prime Factorisation", "Upper & Lower Bounds", "Growth & Decay",
  ]],
  ["Algebra", [
    "Expressions & Simplifying", "Expanding & Factorising", "Linear Equations",
    "Quadratic Equations", "Simultaneous Equations", "Inequalities",
    "Sequences (arithmetic, geometric, nth term, quadratic, Fibonacci)",
    "Straight-line Graphs", "Quadratic Graphs", "Cubic & Reciprocal Graphs",
    "Exponential & Trigonometric Graphs", "Transformations of Graphs",
    "Functions & Inverse Functions", "Iteration",
    "Rearranging Formulae", "Algebraic Fractions", "Algebraic Proof",
  ]],
  ["Geometry & Measures", [
    "Angles in Polygons", "Parallel Lines & Angle Facts",
    "Pythagoras' Theorem", "Trigonometry (SOHCAHTOA)",
    "Sine & Cosine Rules", "3D Trigonometry",
    "Circle Theorems", "Area & Perimeter",
    "Volume & Surface Area", "Similar Shapes & Congruence",
    "Transformations (Translate, Reflect, Rotate, Enlarge)",
    "Constructions & Loci", "Bearings", "Vectors",
  ]],
  ["Probability & Statistics", [
    "Averages (Mean, Median, Mode, Range)", "Frequency Tables",
    "Cumulative Frequency", "Box Plots", "Histograms",
    "Scatter Graphs & Correlation", "Sampling",
    "Tree Diagrams", "Conditional Probability",
    "Venn Diagrams", "Set Notation",
  ]],
];

export default function Subjects() {
  return (
    <div className="min-h-screen">
      <Navbar/>
      <section className="max-w-6xl mx-auto px-6 lg:px-8 py-20">
        <div className="text-xs uppercase tracking-[0.3em] gold-text mb-4">GCSE Maths · Year 7–11</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tighter-x brand-navy mb-6">Curriculum</h1>
        <p className="text-xl text-slate-600 max-w-3xl">Complete coverage across every UK GCSE maths specification — AQA, Edexcel and OCR. Foundation & Higher tier.</p>
      </section>

      <section className="bg-white border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-16">
          <h2 className="font-serif text-3xl brand-navy mb-10">By year group</h2>
          <div className="grid md:grid-cols-5 gap-4">
            {YEARS.map(y => (
              <div key={y.year} className="lift-card p-6 rounded-lg border border-slate-200 bg-slate-50" data-testid={`year-${y.year}`}>
                <div className="font-serif text-4xl brand-navy mb-2">{y.year}</div>
                <div className="text-xs uppercase tracking-widest gold-text mb-3">{y.label}</div>
                <p className="text-sm text-slate-600 leading-relaxed">{y.focus}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-8 py-20">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <h2 className="font-serif text-3xl brand-navy">Every topic, covered.</h2>
            <p className="text-slate-600 mt-2 text-sm">The complete GCSE specification — from place value in Year 7 to algebraic proof in Year 11.</p>
          </div>
          <span className="text-xs uppercase tracking-widest gold-text">50+ topics</span>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {TOPICS.map(([cat, subs]) => (
            <div key={cat} className="p-8 rounded-lg border border-slate-200 bg-white">
              <div className="flex items-center justify-between mb-5">
                <h3 className="font-serif text-2xl brand-navy">{cat}</h3>
                <span className="text-xs text-slate-400 font-mono">{subs.length} topics</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {subs.map(s => <span key={s} className="px-3 py-1.5 text-xs rounded-full bg-slate-100 text-slate-700 border border-slate-200">{s}</span>)}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-4">
          {["AQA","Edexcel","OCR"].map(b => (
            <div key={b} className="p-6 rounded-lg panel-navy text-center">
              <div className="font-serif text-3xl mb-2 brand-gold">{b}</div>
              <div className="text-xs uppercase tracking-widest text-white/60">Fully aligned · Foundation & Higher</div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link to="/signup" className="btn-gold px-8 py-4 rounded-md inline-block" data-testid="subjects-cta">Book free diagnostic lesson</Link>
        </div>
      </section>

      <Footer/>
    </div>
  );
}
